<template>
  <div>
    <NfcCartList
      v-if="
        ribbon_can('nfc_admin_list') &&
        !ribbon_can('nfc_cart_struct') &&
        !ribbon_can('nfc_setting_page_struct') &&
        !ribbon_can('nfc_add_reserve_qr_code')
      "
    />
    <custom-tabs
      v-else
      v-model="tab"
      :tab-items="tabs"
      :window-items="tabs"
      class="ma-5 mt-8"
      grow
    >
      <template v-slot:item="{ item }">
        <component :is="item.component" />
      </template>
    </custom-tabs>
  </div>
</template>
<script>
import NfcCartList from "./NfcCartList.vue";
import NfcQrGenerator from "./NfcQrGenerator.vue";
import QrLayoutBuilder from "./QrLayoutBuilder.vue";
import BatchQrManager from "./BatchQrManager.vue";

export default {
  name: "list",
  components: { NfcCartList, NfcQrGenerator, QrLayoutBuilder, BatchQrManager },

  data() {
    return {
      tab: 0,
    };
  },
  computed: {
    tabs() {
      let tabresult = [
        {
          text: "لیست NFC",
          icon: "credit-card",
          component: "NfcCartList",
          permission: "nfc_admin_list",
        },
        {
          text: "ساخت و رزرو کیوآرکد",
          icon: "qrcode",
          component: "NfcQrGenerator",
          permission: "nfc_add_reserve_qr_code",
        },
        {
          text: "تنظیمات چیدمان و صفحه",
          icon: "cogs",
          component: "QrLayoutBuilder",
          permission: "nfc_setting_page_struct",
        },
        {
          text: "چیدمان کارت nfc",
          icon: "card",
          component: "BatchQrManager",
          permission: "nfc_cart_struct",
        },
      ];
      tabresult = tabresult.filter((x) => this.ribbon_can(x.permission));
      return tabresult;
    },
  },
};
</script>
